exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#sign-in-brand{color:#ffc000;font-weight:bold;font-size:20px}.strike{display:block;text-align:center;overflow:hidden;white-space:nowrap}.strike>span{position:relative;display:inline-block}.strike>span:before,.strike>span:after{content:\"\";position:absolute;top:50%;width:9999px;height:1px;background:#989898}.strike>span:before{right:100%;margin-right:15px}.strike>span:after{left:100%;margin-left:15px}.fb-icon{margin-right:25px;font-size:20px}.fb-button{background-color:#4867aa;color:#fff;text-decoration:none}.fb-button:hover{background-color:#465a9b;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/LoginForm/styles.scss
// module id = 849
// module chunks = 0